/*
 * AI-MOD: BH-PRICE-A11Y-001
 * Purpose: Expose only the active VAT price set to assistive and machine readers.
 * Scope: Product-page [data-vat]/[data-novat] values and the existing VAT toggle.
 * No-JS fallback: Non-VAT prices are server-rendered and visible by default.
 * Remove: Delete this asset and its loader in layout/theme.liquid. See AI-MODIFICATIONS.md.
 */
(function () {
  'use strict';

  function syncPriceVisibility() {
    var vatIsActive = document.body.classList.contains('vat');

    document.querySelectorAll('[data-vat]').forEach(function (price) {
      price.hidden = !vatIsActive;
      price.setAttribute('aria-hidden', String(!vatIsActive));
    });

    document.querySelectorAll('[data-novat]').forEach(function (price) {
      price.hidden = vatIsActive;
      price.setAttribute('aria-hidden', String(vatIsActive));
    });
  }

  document.addEventListener('DOMContentLoaded', syncPriceVisibility);
  document.addEventListener('variant:change', function () {
    window.setTimeout(syncPriceVisibility, 0);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('.toggle-vat__item')) {
      window.setTimeout(syncPriceVisibility, 0);
    }
  });
})();
